import React, { Component, Fragment } from 'react';
import {getFaq, faqs2} from './frpfaq';

class FreeReducedProgramFAQ extends Component {
     createMarkup=(text)=> {
        return {__html: text};
      }
    htmlRenderText=(text)=>{        
        return <div dangerouslySetInnerHTML={this.createMarkup(text)} />;
    }
    render() {
         const schoolInfo = this.props.schoolInfo || {};
         const schoolYear = schoolInfo.schoolYearValue || '';

        // find selected school by schoolId or id (both supported)
        const infoId = schoolInfo.schoolId || schoolInfo.id;
        const selectedSchool = (this.props.schoolList || []).find(sch => String(sch.schoolId) === String(infoId));

        // getFaq expects (schoolYear, selectedSchool)
        const faq = getFaq(schoolYear, selectedSchool) || [];
        return (
            <div style={{overflowY: 'auto', overflowX: 'hidden', height:'calc(100vh - 90px)'}}>
                <h4>Frequently Asked Questions</h4>
                <div className="panel-group" id="accordionOne">
                {
                    faq.map((q,i)=>{
                        return <Fragment>
                            <div className="panel panel-default" style={{marginBottom:'5px'}}>
                                <div className="panel-heading">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href={`#collapse-0-${i}`}>
                                            {q.question}
                                        </a>
                                    </h4>
                                </div>
                            </div>
                            <div id={`collapse-0-${i}`} class="panel-collapse collapse">
                                {
                                    q.htmlRender?this.htmlRenderText(q.answer):
                                    <p>{q.answer}</p>
                                }                                
                            </div>
                        </Fragment>
                    })
                }
                </div>
                <h4>Definitions</h4>
                <div className="panel-group" id="accordionTwo">
                {
                    faqs2.map((q,j)=>{
                        return <Fragment>
                            <div className="panel panel-default" style={{marginBottom:'5px'}}>
                                <div className="panel-heading">
                                    <h4 className="panel-title">
                                        <a data-toggle="collapse" data-parent="#accordion" href={`#collapse-1-${j}`}>
                                            {q.question}
                                        </a>
                                    </h4>
                                </div>
                            </div>
                            <div id={`collapse-1-${j}`} class="panel-collapse collapse">
                                <p>{q.answer}</p>
                                {
                                    q.imgUrl && <img src={q.imgUrl} width={'400px'} />
                                }
                            </div>
                        </Fragment>
                    })
                }
                </div>
            </div>
        );
    }
}

export default FreeReducedProgramFAQ;


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/freeReducedProgramFAQ.jsx